import { createContext } from 'react';

const SensorConnectionContext = createContext(null);

export default SensorConnectionContext;
